import { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import useHttp from '../../../hooks/useHttp'
import { STATE_MACHINE, useMergeContext } from '../../../store/mergeContext'
import { DataGrid, gridClasses } from '@mui/x-data-grid'
import {
  getColumnsModel,
  getConfigOptions,
  mapObjectToLabels
} from '../../Statistics/utils'
import { CRASH_ID_KEY } from '../utils'
import { isStringEqual, or } from '../../../utils'
import { Box, Stack } from '@mui/system'
import {Button, ButtonGroup, Typography, useTheme} from '@mui/material'
import styled from '@emotion/styled'
import PossibleMatchGrid from '../components/PossibleMatchGrid'
import { Trans } from '@lingui/macro'
import { ThemeContext } from '../../../App'
import {StripedDataGrid} from "../../../components/tables/StripedDataGrid";
import SvgCustomIcon from "../../../components/icons/SvgCustomIcon";

const UNIT_ID_KEY = 'Unit id'
const CRASH_DATE_KEY = 'Crash date'
const CRASH_TYPE_KEY = 'Crash type'
const TYPE_KEY = 'Type'
const VEICHLE_REGISTRATION_KEY = 'Vehicle registration year'
const GENDER_KEY = 'Gender'
const NAME_KEY = 'Name'
const SURNAME_KEY = 'Surname'

const KEYS_TO_KEEP_IN_COLUMNS = [
  UNIT_ID_KEY
  , CRASH_ID_KEY
  , UNIT_ID_KEY
  , CRASH_DATE_KEY
  , CRASH_TYPE_KEY
  , TYPE_KEY
  , VEICHLE_REGISTRATION_KEY
  , GENDER_KEY
  , NAME_KEY
  , SURNAME_KEY
]

const keysToFunctions = KEYS_TO_KEEP_IN_COLUMNS.map(isStringEqual)

const keysToKeepFilterFunction = or(...keysToFunctions)

export const MatchTable = () => {
  const {
    selectedCrash,
    matches,
    setMatches,
    setCurrentState,
    setPolicePhotos,
    selectedMatchDetailHospital,
    selectedMatchDetailInsurance
  } = useMergeContext()
  const myLocation = useLocation()
  const token = myLocation.state?.token || null
  const { sendRequest } = useHttp()
  const [crashDetail, setCrashDetail] = useState([{}])
  const [columnGroupingModel, setColumnGroupingModel] = useState([])
  const [selectedCrashRows, setSelectedCrashRows] = useState([])
  const init = useMemo(
    () => myLocation.state?.init || {},
    [myLocation.state?.init]
  )
  const theme = useTheme()
  const [columns, setColumns] = useState([])
  const { mode, toggleTheme } = useContext(ThemeContext)

  const DISABLE_VALIDATE_CRASH = useMemo(() => matches?.length, [matches])
  const DISABLE_MERGE_CRASHES = useMemo(
    () => !selectedMatchDetailInsurance && !selectedMatchDetailHospital
    , [selectedMatchDetailHospital, selectedMatchDetailInsurance]
  )

  const repeatedCrash = useMemo(() => {
    return crashDetail || []
  }, [crashDetail])
  console.log('repeated crash', repeatedCrash)

  console.log('crash detail::', crashDetail)
  console.log('repeated crash::', repeatedCrash)

  // eslint-disable-next-line no-restricted-globals

  const getMatches = useCallback(async () => {
    // eslint-disable-next-line no-restricted-globals
    const matchUrl = new URL(`/api/matches/${selectedCrash}`, location)
    const matchUrlReduced = new URL(matchUrl)
    matchUrlReduced.searchParams.set('format', 'table')
    await sendRequest({
      token
      , url: matchUrlReduced
      , manageResData: res => setMatches(res?.matches)
    })
  }, [token, sendRequest, selectedCrash, setMatches])

  const getCrashes = useCallback(async () => {
    // eslint-disable-next-line no-restricted-globals
    const crashUrl = new URL(`/api/crash/${selectedCrash}`, location)
    const crashUrlReduced = new URL(crashUrl)
    crashUrlReduced.searchParams.set('format', 'table')
    await sendRequest({
      token
      , url: crashUrlReduced
      , manageResData: res => { setCrashDetail(res?.crashes); setPolicePhotos(res?.images) }

    })
  }, [token, sendRequest, selectedCrash])

  useEffect(() => {
    if (selectedCrash) {
      getCrashes()
    }
  }, [selectedCrash, getCrashes])

  useEffect(() => {
    if (selectedCrash) {
      getMatches()
    }
  }, [selectedCrash, getMatches])

  useEffect(() => {
    const { configuration } = init
    // setUser(user)
    // setTotalCrashes(totalCrashes)

    if (repeatedCrash?.length) {
      const configOptions = getConfigOptions(configuration)

      const mappedCrashes = repeatedCrash?.map(crash =>
        mapObjectToLabels(crash, configOptions)
      )
      console.log('mapped crash::', mappedCrashes)

      const preparedRows = mappedCrashes.map((crash, i) => (console.log('crash::', crash), {
        ...(crash?.road || [])
        , ...(crash?.unit || [])
        , ...(crash?.unit?.people || [])
        , ...(crash?.people || [])
        , ...(crash?.crash || [])
        , ...(crash || [])
        , id: `${crash?.crash?.[CRASH_ID_KEY]}.${i}`
      }))

      console.log('prepared rows', preparedRows)

      setSelectedCrashRows(preparedRows)

      const { columns, columnGroupingModel } = getColumnsModel(configuration)
      console.log('columns', columns)
      setColumns(
        columns
          ?.filter(col => keysToKeepFilterFunction(col?.field))
          ?.map(col => ({ ...col, flex: 1 }))
      )
      setColumnGroupingModel(columnGroupingModel)
    }
    // console.log('GM', columnGroupingModel, 'COLS', columns)
  }, [init, repeatedCrash])

  const paginationModel = { page: 0, pageSize: 25 }



  const rowClassNameGetterCrash = params => {
    if (params?.row?.[CRASH_ID_KEY] === selectedCrash) {
      return 'active'
    }
    return ''
  }

  return (
    <Stack gap={6}>
      <Box>
        <Typography sx={{ width: '100%', mt: 2,mb: 2,color: theme.palette.mode === 'light' ? theme.palette.newColors.gray : 'white',fontSize:20,fontWeight:'bold' }} variant="h5">
          <Trans>Selected crash</Trans>
        </Typography>
        <StripedDataGrid
          showColumnVerticalBorder
          showCellVerticalBorder
          unstable_rowSpanning
          rows={selectedCrashRows}
          columns={columns}
          editMode="row"
          columnGroupingModel={columnGroupingModel}
          disableMultipleRowSelection
          getRowClassName={rowClassNameGetterCrash}
          // disableRowSelectionOnClick
          initialState={{
            pagination: { paginationModel }
            , columns: { columnVisibilityModel: { id: false } }
          }}
          pageSizeOptions={[10, 25, 50]}
        />
      </Box>

      <Box>
        <PossibleMatchGrid type="HOSPITAL" />
      </Box>

      <Box>
        <PossibleMatchGrid type="INSURANCE" />
      </Box>
      <Box alignSelf="end" sx={{display:'flex',gap:2}} paddingY={3}>

          <Button
              sx={{background: theme.palette.newColors.pinkGradient,color:'white',display:'flex',gap:1}}
            onClick={() => {
              setCurrentState(STATE_MACHINE.MERGE_PAGE)
            }}
            disabled={DISABLE_MERGE_CRASHES}
          >
            <SvgCustomIcon name={'merge'} color={'white'} />
            <Trans>Merge selected crashes</Trans>
          </Button>
          <Button
              sx={{background: theme.palette.newColors.pinkGradient,color:'white',display:'flex',gap:1}}
            onClick={() => {
              setCurrentState(STATE_MACHINE.MERGE_PAGE)
            }}
            disabled={DISABLE_VALIDATE_CRASH}
            variant="outlined"
          >
            <SvgCustomIcon name={'check'} color={'white'} />
            <Trans>Validate crash</Trans>
          </Button>

      </Box>
    </Stack>
  )
}
